import { posthog } from 'posthog-js'

import type { IUser } from '~/types/user-info-types'

import appConfig from '~/config/app'

import { pick } from '..'

export const identifyUserWithPosthog = (data: Pick<IUser, 'id'> & Partial<IUser>, locale?: string) => {
  // PostHog stays initialized for feature flags in the school platform, but no student is ever
  // identified to it — this call would otherwise send authEmail, birthYear and country.
  if (appConfig.isSchoolPlatform) return

  const userId = `${data.id}`

  const personProperties = pick(data, [
    'authEmail',
    'birthYear',
    'country',
    'countryCode',
    'createdAt',
    'curriculumCountryCode',
    'email',
    'emailStatus',
    'emailVerified',
    'facebookEmail',
    'fullName',
    'gradeLevelId',
    'nickname',
    'phone',
    'pseudoId',
    'role',
    'skill',
    'timezone',
    'userCountry',
    'userType',
    'wantsNewsletter',
    'yearsInSchool',
  ] as const)

  const snakeCaseProperties = Object.entries(personProperties)
    .filter(([, value]) => value !== undefined && value !== null)
    .reduce((acc, [key, value]) => {
      const snakeKey = key.replace(/[A-Z]/g, (match) => `_${match.toLowerCase()}`)
      if (value) acc[snakeKey] = `${value}`
      return acc
    }, {} as Record<string, string>)

  const properties: Record<string, string> = { ...snakeCaseProperties }
  if (locale) properties.locale = locale

  posthog.identify(userId, properties)
}
